// @ts-check
import { COMBINED_SLIDER_ENUMS } from '../combined-slider/const';

export default class BannerItemModel {
  /**
   * @param {import('./interface').TBannerItem} data - bannerItem object
   */
  constructor(data) {
    /**
     * ID
     * @type {number}
     */
    this.id = data.bID;
    /**
     * Background image
     * @type {string}
     */
    this.backgroundImage = data.bURL || '';
    /**
     * External Link
     * @type {string}
     */
    this.url = data.iURL || '';
    /**
     * Open in new tab
     * @type {boolean}
     */
    this.newTab = data.bt;
    /**
     * Order number
     * @type {number}
     */
    if (data.on) {
      this.orderNumber = data.on;
    }
    /**
     * Type
     * @type { typeof COMBINED_SLIDER_ENUMS.BANNER }
     */
    this.type = COMBINED_SLIDER_ENUMS.BANNER;
  }
}